/**
 * Centralized Axios Instance with Interceptors
 * Handles authentication, error handling, and request/response transformations
 */

import axios from 'axios';
import { environment } from '../env/environment';
import logger from './logger';

// Create axios instance with default config
const api = axios.create({
  baseURL: environment.baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add Authorization header and Tenant ID
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('superAdminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add tenant ID header for multi-tenant isolation
    const tenantId = window.__TENANT_ID__ || localStorage.getItem('superadmin_tenant_id');
    if (tenantId) {
      config.headers['X-Tenant-ID'] = tenantId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // Handle 401 Unauthorized - clear invalid token
    if (response?.status === 401) {
      logger.info('401 Unauthorized - clearing invalid token');
      localStorage.removeItem('superAdminToken');
    }

    // Handle 403 Forbidden - insufficient permissions
    if (response?.status === 403) {
      logger.error('Access denied: Insufficient permissions');
    }

    // Handle network errors
    if (!response) {
      logger.error('Network error: Please check your connection');
    }

    return Promise.reject(error);
  }
);

export default api;
